import { FunctionComponent, RefObject } from "react";

import { Spinner } from "@/components/Spinner/Spinner";

interface ComposeLeadsPagingSpinnerProps {
	/** Whether a leads request is in flight (shows the spinner, not the next-page sentinel). */
	isFetching: boolean;
	/** Whether another page can still be loaded. */
	hasMorePages: boolean;
	/** The sentinel the page's infinite-scroll effect observes. */
	leadsEndRef: RefObject<HTMLDivElement>;
}

/**
 * The Compose leads column's paging indicator: the infinite-scroll sentinel when another page
 * exists, the in-flight spinner otherwise, nothing when the list is done (extracted from
 * `Compose.tsx`, PREC-5088).
 */
export const ComposeLeadsPagingSpinner: FunctionComponent<ComposeLeadsPagingSpinnerProps> = ({
	isFetching,
	hasMorePages,
	leadsEndRef,
}) => {
	if (isFetching) {
		return (
			<div className="flex items-center justify-center">
				<Spinner color="#4d66f5" />
			</div>
		);
	}

	if (!hasMorePages) {
		return null;
	}

	return (
		<div ref={leadsEndRef} className="flex items-center justify-center">
			<Spinner color="#4d66f5" />
		</div>
	);
};
